export const ROUTING_NAMES = {
    COURSE: 'course',
    COURSES: 'courses',
    LESSON: 'lesson',
    LESSONS: 'lessons',
}